import {
  FieldProps,
  ErrorMessage,
} from 'formik';

import {
  Switch,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type SwitchProps = {
  align?: string;
  justify?: string;
  label?: string;
  color?: string;
  placeholder?: string;
} & FieldProps;

const SwitchField = ({
  field,
  color,
  align = 'center',
  justify = 'flex-start',
  label = '',
  placeholder = '',
  ...props
}: SwitchProps) => (
  <Flex
    column
    width="100%"
    spacing={5}
  >
    <Flex
      width="100%"
      spacing={5}
      align={align}
      justify={justify}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
        >
          {label}
        </S.Label>
      )}
      <Switch
        {...field}
        {...props}
        id={`${field.name}-id`}
        checked={field.value}
      />
    </Flex>
    <Flex flex="0 1 100%;">
      <ErrorMessage
        name={field.name}
        component={S.Error}
      />
    </Flex>
  </Flex>
);

export default SwitchField;
